<script lang="ts">
  // Svelte/kit
  import { goto } from '$app/navigation';
  import { createEventDispatcher } from 'svelte';
  // UI components
  import DeviceConnector from '$lib/components/DeviceConnector.svelte';
  import LiveStreamIndicator from '$lib/components/LiveStreamIndicator.svelte';
  import ModeToggle from '$lib/components/layout/ModeToggle.svelte';
  import * as DropdownMenu from '$lib/components/ui/dropdown-menu/index';
  import { ChevronUp } from '@lucide/svelte';
  // RoastLog
  import RoastLogLogo from '$lib/images/logo.svelte';
  import logger from '$lib/logger';
  import { clearState, session, userProfile } from '$lib/PersistedState.svelte';
  import { globalState } from '$lib/State.svelte';
  import Navbar from './Navbar.svelte';

  const dispatch = createEventDispatcher();

  let menuOpen = $state(false);
  const VERSION = import.meta.env.PACKAGE_VERSION;

  const handleLogout = () => {
    logger.info('Logging out');
    globalState.deviceConnected = false;
    session.reset();
    clearState();
    goto('/login');
  };
</script>

<!-- left  menu  content-->
<div class="flex items-center">
  <div class="mx-5 h-8 w-8 px-1">
    <RoastLogLogo />
  </div>

  <!-- TODO move this navbar here, since there isn't much to it -->
  <Navbar />

  <!-- hamburger menu -->
  <button type="button" class="-m-2.5 p-2.5 lg:hidden" onclick={() => dispatch('openmenu')}>
    <span class="sr-only">Open sidebar</span>
    <svg
      class="h-6 w-6"
      fill="none"
      viewBox="0 0 24 24"
      stroke-width="1.5"
      stroke="currentColor"
      aria-hidden="true"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
      />
    </svg>
  </button>
</div>

<div class="flex items-center gap-x-4">
  <!-- connected state and control -->
  <DeviceConnector />

  <LiveStreamIndicator />

  <ModeToggle />

  <DropdownMenu.Root
    open={menuOpen}
    onOpenChange={() => {
      menuOpen = !menuOpen;
    }}
  >
    <DropdownMenu.Trigger class="flex">
      <button class="flex" aria-roledescription="Nav">
        {userProfile.current?.first_name}
        {userProfile.current?.last_name}
        <span class="transition duration-100" class:-rotate-180={menuOpen}>
          <ChevronUp />
        </span>
      </button>
    </DropdownMenu.Trigger>
    <DropdownMenu.Content class="w-56">
      <DropdownMenu.Group>
        <DropdownMenu.Label>Settings</DropdownMenu.Label>
        <DropdownMenu.Separator />
        <DropdownMenu.DropdownMenuItem>
          <a href="/settings"> Device settings </a>
        </DropdownMenu.DropdownMenuItem>
        <DropdownMenu.DropdownMenuItem>
          <a href="/events"> Roasting events </a>
        </DropdownMenu.DropdownMenuItem>
        <DropdownMenu.DropdownMenuItem>
          <div>Version: {VERSION}</div>
        </DropdownMenu.DropdownMenuItem>
      </DropdownMenu.Group>
      <DropdownMenu.Separator />
      <DropdownMenu.DropdownMenuItem onclick={handleLogout} class="hover:cursor-pointer ">
        Logout
      </DropdownMenu.DropdownMenuItem>
    </DropdownMenu.Content>
  </DropdownMenu.Root>
</div>
